{
  "version": 1,
  "asset_id": "4c7d321c-7162-47fc-95da-9cc227ad8434",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/4c7d321c-7162-47fc-95da-9cc227ad8434/team-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/4c7d321c-7162-47fc-95da-9cc227ad8434/team-640.webp",
  "original_filename": "team-640.webp",
  "size": 15326,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:27:01Z"
}
